import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import * as bookingService from "../../services/booking.services";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import { SWAL_SETTINGS, showFilterlist } from "../../../../utils/Constants";
import { formateDateWithMonth, formatSecondstoHHMMSS, handleServerValidations, TrimText } from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import CustomRangepicker from "../../common/rangepicker";
// import * as Yup from "yup";
// import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
// import { pdf } from "@react-pdf/renderer";
import SessionLogDetails from "./SessionLogDetails";

const BookingTable = () => {
    const { t } = useTranslation();
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [list, setList] = useState([]);

    const [statsupdate, setStatusUpdate] = useState("false");
    const [datalength, setDataLength] = useState("");
    const [itemperpage] = useState(10);
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true);
    const [search, setSearch] = useState({});
    const [globalsearch, setGlobalSearch] = useState("");
    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: "Consultations", url: "" },
    ];
    const [resetdate, setResetDate] = useState(false);
    const [showNotesModal, setShowNotesModal] = useState(false);
    const [modalData, setModalData] = useState(null);

    useEffect(() => {
        const getData = setTimeout(() => {
            if (search) {
                setLoader(true);
                const formData = new FormData();
                formData.append("page", params.pgno);
                formData.append("per_page", itemperpage);
                formData.append("sort", JSON.stringify(sorting));
                formData.append("search", JSON.stringify(search));
                formData.append("global_search", globalsearch);
                bookingService
                    .List(formData)
                    .then((data) => {
                        setDataLength(data.data.total_records);
                        // setSerialNo(data.data.offset);
                        setList(data && data.data && data.data.list ? data.data.list : []);
                        //   console.log("data.data.data_ids", data.data.data_ids);

                        setPage(data && data.data && data.data.page ? data.data.page : 1);
                        setLoader(false);
                    })
                    .catch((error) => {
                        console.log("error ====> ", error);
                    });
            }
        }, 300);
        return () => clearTimeout(getData);
    }, [location, statsupdate, sorting, search, globalsearch, itemperpage, params.pgno]);

    const viewfunction = (row) => {
        navigate(`/admin/consultation/view/${row._id}`);
    };

    const ChangeStatus = (data, Num) => {
        let ids = Array.isArray(data) ? data : [data];
        const formData = new FormData();
        formData.append("o_id", JSON.stringify(ids));
        formData.append("status", Num);
        Swal.fire({
            customClass: "swal-wide",
            title: t("msg_are_you_sure"),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: t("btn_cancel"),
            confirmButtonColor: "#403fad",
            cancelButtonColor: "#f1388b",
            confirmButtonText: t("btn_yes"),
        }).then((result) => {
            // console.log("result", result);
            if (result.isConfirmed) {
                bookingService
                    .Status(formData)
                    .then((response) => {
                        // console.log("kkkk---", response);
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            setStatusUpdate(!statsupdate);
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("error===>");
                    });
            }
        });
    };

    function Deletefunction(data) {
        Swal.fire({
            customClass: "swal-wide",
            title: t("msg_are_you_sure"),
            text: t("you_not_be_able_to_revert_this"),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: t("btn_cancel"),
            confirmButtonColor: "#403fad",
            cancelButtonColor: "#f1388b",
            confirmButtonText: t("btn_yes_delete"),
        }).then((result) => {
            if (result.isConfirmed) {
                const formdata = new FormData();
                let ids = Array.isArray(data) ? data : [data];
                // formdata.append("o_id", row._id);
                formdata.append("o_id", JSON.stringify(ids));
                bookingService
                    .Delete(formdata)
                    .then((response) => {
                        // console.log("🚀 ~ .then ~ response:", response);
                        setStatusUpdate(!statsupdate);
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("deleteError");
                    });
            }
        });
    }

    // sorting function start
    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    };
    // sorting end

    // search or filter function
    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    };
    // search or filer end

    const resetFilter = (e) => {
        e.preventDefault();
        setGlobalSearch("");
        prepareSearch();
        setSearch({});
        setResetDate(!resetdate);
        // $("#defaultstatus")[0].selectedIndex = 0;
    };

    // To show notes modal
    const handleShowNotes = (row) => {
        setModalData(row);
        setShowNotesModal(true);
    };
    console.log("modalData", modalData);
    console.log("showNotesModal", showNotesModal);

    const generateFullNoteText = (row) => {
        return `
      User: ${row.user?.name}
      Astrologer: ${row.astrologer?.name}
      Service Type: ${row.service_type}
      Mode: ${row.mode_of_consultation}
      Duration: ${row.duration} sec (${row.charged_duration_in_minutes} min charged)
      Base Price/Min: ₹${row.base_price_per_minute}
      Astrologer Discount: ${row.astrologer_offer_percentage}%
      Platform Discount: ${row.platform_offer_percentage}%
      Total Amount: ₹${row.final_amount}
      Astrologer Earnings: ₹${row.astrologer_earning_amount}
      Platform Commission (%): ${row.platform_commission_percentage}%
      Platform Earnings: ₹${row.platform_commission_amount}
      Session Notes: ${row.session_notes}
      Created At: ${formateDateWithMonth(row.createdAt)}
      `;
    };
    // To close notes modal
    const handleCloseNotes = () => {
        setShowNotesModal(false);
        setModalData(null);
    };

    const handleDownloadNotes = (notes, userId) => {
        const element = document.createElement("a");
        const file = new Blob([notes], { type: "text/plain" });
        element.href = URL.createObjectURL(file);
        element.download = `session_notes_${userId || "unknown"}.txt`;
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    };

    // Utility function to get only filled session fields
// const prepareSessionData = (row) => {
//   const data = {};
//   if (row.user?.name) data.userName = row.user.name;
//   if (row.astrologer?.name) data.astrologerName = row.astrologer.name;
//   if (row.service_type) data.serviceType = row.service_type.replace(/_/g, " ");
//   if (row.mode_of_consultation) data.mode = row.mode_of_consultation;
//   if (row.duration) data.duration = `${formatSecondstoHHMMSS(row.duration)} (${row.charged_duration_in_minutes} min charged)`;
//   if (row.base_price_per_minute !== null && row.base_price_per_minute !== undefined) data.basePrice = `₹${Number(row.base_price_per_minute).toFixed(2)}`;
//   if (row.astrologer_offer_percentage !== null && row.astrologer_offer_percentage !== undefined) data.astroDiscount = `${row.astrologer_offer_percentage}%`;
//   if (row.platform_offer_percentage !== null && row.platform_offer_percentage !== undefined) data.platformDiscount = `${row.platform_offer_percentage}%`;
//   if (row.final_amount !== null && row.final_amount !== undefined) data.totalAmount = `₹${Number(row.final_amount).toFixed(2)}`;
//   if (row.astrologer_earning_amount !== null && row.astrologer_earning_amount !== undefined) data.astroEarnings = `₹${Number(row.astrologer_earning_amount).toFixed(2)}`;
//   if (row.platform_commission_percentage !== null && row.platform_commission_percentage !== undefined) data.platformCommission = `${Number(row.platform_commission_percentage).toFixed(2)}%`;
//   if (row.platform_commission_amount !== null && row.platform_commission_amount !== undefined) data.platformEarnings = `₹${Number(row.platform_commission_amount).toFixed(2)}`;
//   if (row.session_notes && row.session_notes.trim() !== "") data.sessionNotes = row.session_notes;
//   if (row.createdAt) data.createdAt = formateDateWithMonth(row.createdAt);
//   return data;
// };

//     const styles = StyleSheet.create({
//   page: { padding: 40 },
//   header: { marginBottom: 30, borderBottomWidth: 3, borderBottomColor: "#403fad", paddingBottom: 15 },
//   headerTitle: { fontSize: 28, color: "#403fad", textAlign: "center", marginBottom: 5 },
//   headerSubtitle: { fontSize: 12, color: "#666", textAlign: "center" },
//   section: { marginBottom: 20 },
//   sectionTitle: { backgroundColor: "#f0f0f0", padding: 10, fontWeight: "bold", color: "#403fad", borderLeftWidth: 4, borderLeftColor: "#403fad", marginBottom: 10 },
//   row: { display: "flex", flexDirection: "row", justifyContent: "space-between", paddingVertical: 8, borderBottomWidth: 1, borderBottomColor: "#eee" },
//   label: { fontWeight: "bold", color: "#403fad", width: "45%" },
//   value: { color: "#333", width: "55%", textAlign: "right" },
//   notes: { backgroundColor: "#f9f9f9", padding: 12, borderLeftWidth: 4, borderLeftColor: "#403fad", fontSize: 10 },
//   footer: { marginTop: 40, textAlign: "center", fontSize: 11, color: "#999", borderTopWidth: 1, borderTopColor: "#eee", paddingTop: 10 },
// });

// const handleDownloadNotesPDF = async (row) => {
//   const data = prepareSessionData(row);

//   const MyDocument = (
//     <Document>
//       <Page size="A4" style={styles.page}>
//         <View style={styles.header}>
//           <Text style={styles.headerTitle}>Session Details Report</Text>
//           <Text style={styles.headerSubtitle}>Generated on {new Date().toLocaleString()}</Text>
//         </View>

//         <View style={styles.section}>
//           <Text style={styles.sectionTitle}>👤 Participant Information</Text>
//           {data.userName && <View style={styles.row}><Text style={styles.label}>User Name:</Text><Text style={styles.value}>{data.userName}</Text></View>}
//           {data.astrologerName && <View style={styles.row}><Text style={styles.label}>Astrologer Name:</Text><Text style={styles.value}>{data.astrologerName}</Text></View>}
//         </View>

//         <View style={styles.section}>
//           <Text style={styles.sectionTitle}>📋 Consultation Details</Text>
//           {data.serviceType && <View style={styles.row}><Text style={styles.label}>Service Type:</Text><Text style={styles.value}>{data.serviceType}</Text></View>}
//           {data.mode && <View style={styles.row}><Text style={styles.label}>Mode:</Text><Text style={styles.value}>{data.mode}</Text></View>}
//           {data.duration && <View style={styles.row}><Text style={styles.label}>Duration:</Text><Text style={styles.value}>{data.duration}</Text></View>}
//         </View>

//         <View style={styles.section}>
//           <Text style={styles.sectionTitle}>💰 Pricing & Discounts</Text>
//           {data.basePrice && <View style={styles.row}><Text style={styles.label}>Base Price/Min:</Text><Text style={styles.value}>{data.basePrice}</Text></View>}
//           {data.astroDiscount && <View style={styles.row}><Text style={styles.label}>Astrologer Discount:</Text><Text style={styles.value}>{data.astroDiscount}</Text></View>}
//           {data.platformDiscount && <View style={styles.row}><Text style={styles.label}>Platform Discount:</Text><Text style={styles.value}>{data.platformDiscount}</Text></View>}
//           {data.totalAmount && <View style={styles.row}><Text style={styles.label}>Total Amount:</Text><Text style={{...styles.value, fontWeight: "bold", color: "#27ae60"}}>{data.totalAmount}</Text></View>}
//         </View>

//         <View style={styles.section}>
//           <Text style={styles.sectionTitle}>💵 Earnings & Commission</Text>
//           {data.astroEarnings && <View style={styles.row}><Text style={styles.label}>Astrologer Earnings:</Text><Text style={styles.value}>{data.astroEarnings}</Text></View>}
//           {data.platformCommission && <View style={styles.row}><Text style={styles.label}>Platform Commission (%):</Text><Text style={styles.value}>{data.platformCommission}</Text></View>}
//           {data.platformEarnings && <View style={styles.row}><Text style={styles.label}>Platform Earnings:</Text><Text style={styles.value}>{data.platformEarnings}</Text></View>}
//         </View>

//         {data.sessionNotes && (
//           <View style={styles.section}>
//             <Text style={styles.sectionTitle}>📝 Session Notes</Text>
//             <Text style={styles.notes}>{data.sessionNotes}</Text>
//           </View>
//         )}

//         {data.createdAt && (
//           <View style={styles.section}>
//             <Text style={styles.sectionTitle}>📅 Metadata</Text>
//             <View style={styles.row}><Text style={styles.label}>Created At:</Text><Text style={styles.value}>{data.createdAt}</Text></View>
//           </View>
//         )}

//         <View style={styles.footer}>
//           <Text>This is an official session record. Generated by Admin Portal.</Text>
//         </View>
//       </Page>
//     </Document>
//   );

//   // Generate and download
//   try {
//     const blob = await pdf(MyDocument).toBlob();
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.download = `session_notes_${row._id || "unknown"}.pdf`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);
//   } catch (error) {
//     console.error("PDF generation error:", error);
//     alert("Error generating PDF. Please try again.");
//   }
// };

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            {/* table section */}
            <div className="animation_fade">
                <div className="card custom-card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h6 className="main-content-label">Consultations</h6>
                            <div className="d-flex align-items-center">
                                <div className="form-group mb-0 me-3">
                                    <div className="form-group mb-0 rangepicker_container filter_design">
                                        <i className="fa fa-search calender_icon"></i>
                                        <input
                                            type="search"
                                            className="form-control"
                                            value={globalsearch}
                                            placeholder={t("input_placeholder_search")}
                                            onChange={(e) => {
                                                setGlobalSearch(e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="me-3">
                                    <CustomRangepicker
                                        GetDateRange={(e) => {
                                            prepareSearch("createdAt", e);
                                        }}
                                        resetdate={resetdate}
                                    />
                                </div>
                                {/* <div className="me-3">
                                    <StatusFilter
                                        data={showFilterlist}
                                        prepareSearch={prepareSearch}
                                    />
                                    </div> */}

                                <button type="reset" value="Reset" onClick={resetFilter} className="btn btn-warning float-right mr-2">
                                    {t("btn_reset_filter")}
                                </button>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                                <thead>
                                    <tr>
                                        <th className="position-relative select_head">
                                            <span>{t("list_heading_sno")}</span>
                                        </th>
                                        <th className="position-relative select_head">
                                            <span>Booking ID</span>
                                        </th>
                                        <th>
                                            <div className="sorting_column">
                                                <span>User Name</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="sorting_column">
                                                <span>Astrologer Name</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="sorting_column">
                                                <span>Service Type</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="sorting_column">
                                                <span>Mode</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="rating_head">
                                                <span>Duration</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="rating_head">
                                                <span>Base/Min</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="rating_head">
                                                <span>Astro Discount</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="rating_head">
                                                <span>Platform Discount</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="rating_head">
                                                <span>Total Amount</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="rating_head">
                                                <span>Astrologer Earnings</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="rating_head">
                                                <span>Platform commission(%)</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="rating_head">
                                                <span>Platform Earnings</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="rating_head">
                                                <span>Session Notes</span>
                                            </div>
                                        </th>
                                        <th className="created_head">
                                            <div className="sorting_column">
                                                <span>{t("list_heading_created_date")}</span>
                                                <Sorting sort={sorting} handleSort={handleSort} defaultSorting={defaultSorting} column="createdAt" />
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ? (
                                        <tr>
                                            <td colSpan={12}>
                                                <Loader />
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            {list.length ? (
                                                list.map((row, i) => (
                                                    <tr key={i}>
                                                        <td>{(page - 1) * itemperpage + i + 1}</td>
                                                        <td>
                                                            <div className="d-flex">{row?.booking_tracking_id ? `#${row?.booking_tracking_id}` : "-"}</div>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex">{row?.user?.name || "N/A"}</div>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex">{row?.astrologer?.name || "N/A"}</div>
                                                        </td>
                                                        <td>{row?.service_type ? row.service_type.replace(/_/g, " ") : "N/A"}</td>
                                                        <td>{row?.mode_of_consultation || "N/A"}</td>
                                                        <td>{row?.duration ? `${formatSecondstoHHMMSS(row.duration)} (${row?.charged_duration_in_minutes} min charged)` : "N/A"}</td>
                                                        <td>
                                                            ₹{row?.base_price_per_minute !== undefined && row?.base_price_per_minute !== null ? Number(row.base_price_per_minute).toFixed(2) : "N/A"}
                                                        </td>
                                                        <td>{typeof row?.astrologer_offer_percentage === "number" ? `${row.astrologer_offer_percentage}%` : "N/A"}</td>
                                                        <td>{typeof row?.platform_offer_percentage === "number" ? `${row.platform_offer_percentage}%` : "N/A"}</td>
                                                        <td>₹{row?.final_amount !== undefined && row?.final_amount !== null ? Number(row.final_amount).toFixed(2) : "N/A"}</td>
                                                        <td>
                                                            <div className="d-flex">
                                                                ₹
                                                                {row?.astrologer_earning_amount !== undefined && row?.astrologer_earning_amount !== null
                                                                    ? Number(row.astrologer_earning_amount).toFixed(2)
                                                                    : "N/A"}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex">
                                                                {row?.platform_commission_percentage !== undefined && row?.platform_commission_percentage !== null
                                                                    ? Number(row.platform_commission_percentage).toFixed(2)
                                                                    : "0.00"}{" "}
                                                                %
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex">
                                                                ₹
                                                                {row?.platform_commission_amount !== undefined && row?.platform_commission_amount !== null
                                                                    ? Number(row.platform_commission_amount).toFixed(2)
                                                                    : "N/A"}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            {/* {row?.session_notes && row.session_notes.trim() !== "" ? ( */}
                                                                <>
                                                                    <button className="btn signbtn btn-link" title="View" onClick={() => handleShowNotes(row)}>
                                                                        View
                                                                    </button>
                                                                </>
                                                            {/* ) : (
                                                                <span>N/A</span>
                                                            )} */}
                                                        </td>
                                                        <td>{row.createdAt ? formateDateWithMonth(row.createdAt) : "N/A"}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={12} className="text-center">
                                                        {t("msg_no_records")}
                                                    </td>
                                                </tr>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="" id="example1_info" role="status" aria-live="polite">
                            <b>
                                {t("msg_total_records")} : {datalength ? datalength : "0"}
                            </b>
                        </div>
                        {datalength && datalength > 0 ? (
                            <CustomPagination
                                datalength={datalength}
                                itemperpage={itemperpage}
                                currentPage={page}
                                setPage={setPage}
                                pageRoute={[
                                    {
                                        name: "Consultation",
                                        path: "/admin/consultation/list",
                                    },
                                ]}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>

            {/* session notes modal */}
            {/* {showNotesModal && modalData && (
                // <div className="modal fade show" style={{ display: "block" }}>
                <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "#0008", zIndex: 9999 }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Session Details</h5>
                                <button type="button" className="close" onClick={handleCloseNotes}>
                                    &times;
                                </button>
                            </div>
                            <div className="modal-body">
                                <b>User:</b> {modalData.user?.name}
                                <br />
                                <b>Astrologer:</b> {modalData.astrologer?.name}
                                <br />
                                <b>Service Type:</b> {modalData.service_type}
                                <br />
                                <b>Mode:</b> {modalData.mode_of_consultation}
                                <br />
                                <b>Duration:</b> {modalData.duration} sec ({modalData.charged_duration_in_minutes} min charged)
                                <br />
                                <b>Base Price/Min:</b> ₹{modalData.base_price_per_minute}
                                <br />
                                <b>Astrologer Discount:</b> {modalData.astrologer_offer_percentage}%<br />
                                <b>Platform Discount:</b> {modalData.platform_offer_percentage}%<br />
                                <b>Total Amount:</b> ₹{modalData.final_amount}
                                <br />
                                <b>Astrologer Earnings:</b> ₹{modalData.astrologer_earning_amount}
                                <br />
                                <b>Platform Commission (%):</b> {modalData.platform_commission_percentage}%<br />
                                <b>Platform Earnings:</b> ₹{modalData.platform_commission_amount}
                                <br />
                                <b>Session Notes:</b>
                                <pre>{modalData.session_notes}</pre>
                                <b>Created At:</b> {formateDateWithMonth(modalData.createdAt)}
                                <br />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" onClick={() => handleDownloadNotes(generateFullNoteText(modalData), modalData._id)}>
                                    Download
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={handleCloseNotes}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )} */}
            {/* {showNotesModal && modalData && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.5)",
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflowY: "auto"
    }}
  >
    <div
      style={{
        background: "#fff",
        borderRadius: 8,
        width: "95%",
        maxWidth: 600,
        padding: 30,
        boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
        position: "relative",
        margin: "20px auto"
      }}
    >
      <h5 style={{marginTop: 0, marginBottom: 20}}>Session Details</h5>
      <button
        style={{
          position: "absolute",
          top: 10,
          right: 16,
          background: "none",
          border: "none",
          fontSize: 24,
          cursor: "pointer",
          color: "#888"
        }}
        onClick={handleCloseNotes}
        aria-label="Close modal"
      >
        &times;
      </button>

      <div style={{marginBottom: 16, lineHeight: "1.8"}}>
        {modalData.user?.name && (
          <>
            <b>User:</b> {modalData.user.name} <br />
          </>
        )}
        {modalData.astrologer?.name && (
          <>
            <b>Astrologer:</b> {modalData.astrologer.name} <br />
          </>
        )}
        {modalData.service_type && (
          <>
            <b>Service Type:</b> {modalData.service_type.replace(/_/g, " ")} <br />
          </>
        )}
        {modalData.mode_of_consultation && (
          <>
            <b>Mode:</b> {modalData.mode_of_consultation} <br />
          </>
        )}
        {modalData.duration && (
          <>
            <b>Duration:</b> {formatSecondstoHHMMSS(modalData.duration)} ({modalData.charged_duration_in_minutes} min charged) <br />
          </>
        )}
        {modalData.base_price_per_minute !== null && modalData.base_price_per_minute !== undefined && (
          <>
            <b>Base Price/Min:</b> ₹{Number(modalData.base_price_per_minute).toFixed(2)} <br />
          </>
        )}
        {modalData.astrologer_offer_percentage !== null && modalData.astrologer_offer_percentage !== undefined && (
          <>
            <b>Astrologer Discount:</b> {modalData.astrologer_offer_percentage}% <br />
          </>
        )}
        {modalData.platform_offer_percentage !== null && modalData.platform_offer_percentage !== undefined && (
          <>
            <b>Platform Discount:</b> {modalData.platform_offer_percentage}% <br />
          </>
        )}
        {modalData.final_amount !== null && modalData.final_amount !== undefined && (
          <>
            <b>Total Amount:</b> ₹{Number(modalData.final_amount).toFixed(2)} <br />
          </>
        )}
        {modalData.astrologer_earning_amount !== null && modalData.astrologer_earning_amount !== undefined && (
          <>
            <b>Astrologer Earnings:</b> ₹{Number(modalData.astrologer_earning_amount).toFixed(2)} <br />
          </>
        )}
        {modalData.platform_commission_percentage !== null && modalData.platform_commission_percentage !== undefined && (
          <>
            <b>Platform Commission (%):</b> {Number(modalData.platform_commission_percentage).toFixed(2)}% <br />
          </>
        )}
        {modalData.platform_commission_amount !== null && modalData.platform_commission_amount !== undefined && (
          <>
            <b>Platform Earnings:</b> ₹{Number(modalData.platform_commission_amount).toFixed(2)} <br />
          </>
        )}
        {modalData.session_notes && modalData.session_notes.trim() !== "" && (
          <>
            <b>Session Notes:</b>
            <pre style={{whiteSpace: "pre-wrap", margin: "8px 0", background: "#f5f5f5", padding: "10px", borderRadius: 4, fontSize: 12}}>
              {modalData.session_notes}
            </pre>
          </>
        )}
        {modalData.createdAt && (
          <>
            <b>Created At:</b> {formateDateWithMonth(modalData.createdAt)} <br />
          </>
        )}
      </div>

      <div style={{display: "flex", gap: "10px"}}>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => handleDownloadNotesPDF(modalData)}
        >
          Download as PDF
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCloseNotes}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)} */}

{showNotesModal && modalData && (
<SessionLogDetails modalData={modalData} handleCloseNotes={handleCloseNotes} />
)}

        </>
    );
};

export default BookingTable;
